import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

export const getGuid = () => uuidv4();

export const validateEmail = (email: string) =>
  email
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

export const formatDate = (unixTimestamp?: number) => {
  if (!unixTimestamp) return '-';
  return moment.unix(unixTimestamp).format('DD/MM/YYYY');
};

export const formatDate2 = (unixTimestamp: number) => moment.unix(unixTimestamp).format('MMM DD');

export const formatDate3 = (unixTimestamp: number) =>
  moment.unix(unixTimestamp).format('MMM DD, YYYY');

export const formatDate4 = (unixTimestamp: number) =>
  moment.unix(unixTimestamp).format('DD. MMM. YYYY');

export const formatTime = (unixTimestamp?: number) => {
  if (!unixTimestamp) return '-';
  if (isNaN(unixTimestamp)) return '-';
  return moment.unix(unixTimestamp).format('HH:mm');
};

export const formatTime2 = (unixTimestamp?: number) => {
  if (!unixTimestamp) return '-';
  if (isNaN(unixTimestamp)) return '-';
  return moment.unix(unixTimestamp).format('H:mm');
};

export const isObjectEmpty = (obj: any) => {
  if (obj === undefined) {
    return true;
  }

  return Object.keys(obj).length === 0;
};

export const setCookie = (favoriteTeams: string[], tournamentDate: Date) => {
  tournamentDate.setDate(tournamentDate.getDate() + 1); // Expires 1 day after the tournament
  document.cookie =
    'tamil-football-favorites=' +
    JSON.stringify(favoriteTeams) +
    '; expires= ' +
    tournamentDate.toUTCString();
};

export const getFavoriteTeamsFromCookies = () => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; tamil-football-favorites=`);
  if (parts.length === 2) return JSON.parse(parts.pop()?.split(';').shift() ?? '[]');
};

export const capitalizeFirstLetter = (str: string) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export function formatPhoneNumber(phoneNumber: string) {
  // Fjern alle ikke-numeriske tegn (som mellemrum eller bindestreger)
  const cleaned = phoneNumber.replace(/\D/g, '');

  // Tjek om telefonnummeret har den korrekte længde
  if (cleaned.length === 8) {
    // Del telefonnummeret op i 4 grupper af 2 cifre
    return cleaned.replace(/(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4');
  } else {
    throw new Error('Telefonnummeret skal have 8 cifre');
  }
}

export const createRevolutOrder = async (amount: number) => {
  try {
    const res = await fetch('https://rzllkafhldrymzyeqdno.functions.supabase.co/create-order', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        amount: amount * 100,
        currency: 'DKK',
        redirect_url: 'https://www.melfar-serviceudlejning.dk/thanks',
      }),
    });

    if (!res.ok) {
      const errorData = await res.json().catch(() => ({})); // fallback hvis ingen JSON
      console.error('API error:', res.status, errorData);
      throw new Error(`API returned status ${res.status}`);
    }

    return await res.json();
  } catch (e) {
    console.error('Network or unknown error:', e);
    throw new Error('Failed to create order');
  }
};

export const redirectToPayment = async (orderId: string) => {
  try {
    const res = await fetch(
      `https://rzllkafhldrymzyeqdno.functions.supabase.co/getRevolutOrder/${orderId}`,
      {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      }
    );

    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      console.error('Failed to fetch order from edge function', errorData);
      return;
    }

    const data = await res.json();

    if (data.checkout_url) {
      window.location.href = data.checkout_url;
    } else {
      console.error('Order data missing checkout_url or token', data);
    }
  } catch (error) {
    console.error('Error redirecting to payment', error);
  }
};
